<template>
    <v-container class="blog-page">
        <v-layout d-flex wrap xs12>
            <v-flex xs12 sm6 md4 lg3 d-flex>
                <h2 style="margin-top: 0.5rem">Вопросы</h2>
            </v-flex>
            <v-flex xs12 sm6 md3 d-flex class="selector-block" v-if="filter">
                <v-menu
                    offset-y
                    :position-x="0"
                    :position-y="0"
                    transition="slide-y-transition"
                    bottom
                    :close-on-content-click="false"
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="white"
                            light
                            v-on="on"
                            :class="'p-0'"
                        >
                            <span>{{ selectorText }}</span>
                            <span class="pl-5"><img :src="'/svg/select.svg'"/></span>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-tile
                            v-for="(item, index) in items"
                            :key="index"
                            @click="checkCategory(item.id)"
                        >
                            <v-list-tile-title
                                :class="activeCategories.includes(item.id) ? 'active pl-3' : 'pl-3'"
                            >{{ item.name }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                    <v-btn
                        color="primary"
                        dark
                        @click="changeCategory"
                    >
                        Показать
                    </v-btn>
                </v-menu>
            </v-flex>
            <v-flex d-flex xs12 sm12 md12 lg6 class="categories-list-block" v-if="activeShowCategories.length">
                <div v-for="item in activeShowCategories" :key="item.id">
                    {{ item.name }}
                    <a @click="removeCategory(item.id)">
                        <img :src="'/svg/cross.svg'"/>
                    </a>
                </div>
            </v-flex>
        </v-layout>

        <v-layout
            d-block class="blog-qna"
            v-if="qna.length"
        >
            <v-flex
                v-for="item in questions"
                :key="item.id"
                @click="toggleAnswer(item.id)"
                :class="['blog-qna__item', item.active ? 'opened' : 'closed']"
            >
                <v-flex class="blog-qna__item__question"><h3 v-html="item.question"></h3></v-flex>
                <v-flex class="blog-qna__item__answer"><p v-html="item.answer"></p></v-flex>
            </v-flex>
        </v-layout>


    </v-container>
</template>
<script>

export default {
    props: ['qna', 'categories', 'filter', 'page'],
    
    data: () => ({
        items: [],
        defaultSelected: {},
        activeCategories: [],
        activeShowCategories: [],
        selectorText: 'Все темы',
        questions: {}
    }),
    
    mounted () {
        if(this.categories){
            this.items = this.categories.map((item) => {
                return {id:item.id, name: item.name, active: false}
            })
        }
        if(this.qna){
            this.questions = this.qna.map((item) => {
                item.active = false
                return item
            })
        }
    },

    created: () => {

    },

    methods: {

        toggleAnswer(id) {
            this.questions = this.questions.map((item) => {
                if(item.id == id && item.active == true){
                    item.active = false
                    return item
                }
                if(item.id == id && item.active == false){
                    item.active = true
                    return item
                }
                return item
            })
        },
        
        setSelectorText() {
            this.selectorText = 'Все темы'
            if(this.activeCategories.length == 1) {
                this.selectorText = 'Выбрана 1 тема'
            } else if(this.activeCategories.length >= 2 && this.activeCategories.length < 5) {
                this.selectorText = `Выбрано ${this.activeCategories.length} темы`
            } else if(this.activeCategories.length >= 5) {
                this.selectorText = `Выбрано ${this.activeCategories.length} тем`
            }
        },

        checkCategory(id){
            let isset = this.activeCategories.find((item) => {
                if(item == id){
                    return true
                }
                return false
            })
            if(isset){
                this.activeCategories = this.activeCategories.filter(function(item) {
                    return item !== id
                })
            }
            else{
                this.activeCategories.push(id)
            }
            this.setSelectorText()
        },

        changeCategory() {
            if(this.activeCategories.length){
                this.questions = this.qna.filter((item) => {
                    if (this.activeCategories.find((category) => { if(category == item.category_id) { return true } }) ){
                        item.active = false
                        return item
                    }
                    return false
                })
                return
            }
            this.questions = this.qna
        },

        removeCategory(id){
            this.checkCategory(id)
            this.changeCategory()
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/js/components/blog/Qna.vue